import { CredentialItem } from './credential-item'

export class FifaCredentialItem extends CredentialItem {

  public constructor(data: any) {
    super(data)

    const value = this.credential.eligibility_status
    switch (value) {
      case 'complete': {
        this.validityLabel = `Completed ${this.getDate(this.credential.effective_at)}`
        this.setStatusTag({ value })
        break
      }
      case 'error': this.setStatusTag({ color: 'red', value })
    }
  }

}
